import { useSelector } from "react-redux";
import useLogin from "./useLogin";
import LoadingAction from "@common/redux/actions/LoadingAction";
import LinkSessionAction from "@common/redux/actions/LinkSessionAction";
import SessionClient from "@common/api/SessionClient";
import ComplianceSessionClient from "@common/api/ComplianceSessionClient";
import SessionModalAction from "@common/redux/actions/SessionModalAction";
import SessionalDetailsAction from "@common/redux/actions/SessionalDetailsAction";

const useSessionModal = () => {
  const data = useSelector((state) =>
    SessionalDetailsAction.getStatePath(state),
  );
  const { periodType, pageNumber, includeNonAlerts } = data;

  const modalData = useSelector((state) =>
    SessionModalAction.getStatePath(state),
  );

  const setState = SessionalDetailsAction.dispatch;
  const setLinkSessionState = LinkSessionAction.dispatch;

  const [{ isDesktop, site }] = useLogin();

  const { sessionkey } = useSelector((state) => state.logIn ?? {});

  const fetchAlertSessions = (periodId = null, linkedSessionGuids = null) => {
    const period = periodId ?? periodType;

    if (isDesktop) sessionStorage.setItem("token", sessionkey);

    const fnAlertSessions = isDesktop
      ? ComplianceSessionClient.SessionsComplianceCMS(
          site?.id,
          period,
          pageNumber,
          includeNonAlerts,
        )
      : linkedSessionGuids && linkedSessionGuids.length > 0
        ? SessionClient.SessionByGuid(linkedSessionGuids)
        : null;

    LoadingAction.set(true).then(() => {
      fnAlertSessions?.then((response) => {
        const { grid } = response;
        setState({ grid });
        setLinkSessionState({ linkedSessionData: response?.grid?.data });
      });
      SessionClient.AlertSessions(period, pageNumber, includeNonAlerts)
        .then((response) => {
          setState({ ...response });
        })
        .finally(() => {
          LoadingAction.set(false);
        });
    });
  };

  const fetchComplianceSessions = (
    machineInstallationId,
    periodType,
    pageNumber,
  ) => {
    SessionClient.SessionsCompliance(
      machineInstallationId,
      periodType,
      pageNumber,
    ).then((response) => {
      SessionalDetailsAction.dispatch({
        ...response,
        machineInstallationId: alert.machineInstallationId,
      });
    });
  };

  return { ...data, ...modalData, fetchAlertSessions, fetchComplianceSessions };
};

export default useSessionModal;
